const GET_IP_ADDRESS_REQUEST = 'tcfwebchat/GET_IP_ADDRESS_REQUEST'
const GET_IP_ADDRESS_SUCCESS = 'tcfwebchat/GET_IP_ADDRESS_SUCCESS'
const GET_IP_ADDRESS_FAILURE = 'tcfwebchat/GET_IP_ADDRESS_FAILURE'

const POST_MESSAGE_REQUEST = 'tcfwebchat/POST_MESSAGE_REQUEST'
const POST_MESSAGE_SUCCESS = 'tcfwebchat/POST_MESSAGE_SUCCESS'
const POST_MESSAGE_FAILURE = 'tcfwebchat/POST_MESSAGE_FAILURE'

const POST_QUICKREPLY_REQUEST = 'tcfwebchat/POST_QUICKREPLY_REQUEST'
const POST_QUICKREPLY_SUCCESS = 'tcfwebchat/POST_QUICKREPLY_SUCCESS'
const POST_QUICKREPLY_FAILURE = 'tcfwebchat/POST_QUICKREPLY_FAILURE'

const RECEIVE_DATA = 'tcfwebchat/RECEIVE_DATA'
const STORE_BOT_DATA = 'tcfwebchat/STORE_BOT_DATA'

const SET_EMOTION = 'tcfwebchat/SET_EMOTION'

export default {
  GET_IP_ADDRESS_REQUEST,
  GET_IP_ADDRESS_SUCCESS,
  GET_IP_ADDRESS_FAILURE,

  POST_MESSAGE_REQUEST,
  POST_MESSAGE_SUCCESS,
  POST_MESSAGE_FAILURE,

  POST_QUICKREPLY_REQUEST,
  POST_QUICKREPLY_SUCCESS,
  POST_QUICKREPLY_FAILURE,

  STORE_BOT_DATA,
  RECEIVE_DATA,

  SET_EMOTION,
}



// WEBPACK FOOTER //
// ./src/redux/types.js